import {
  AiCreativeTemplateSource,
  AiCreativeTemplateType,
  CreativeTemplate,
  CreativeTemplateSource,
  CreativeTemplateType,
} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {FilterToolSchemaField} from 'common/src/modules/shared/copilot/tools/filterTableTool/filterTableTool.types';

const templateTypeConversions: Record<CreativeTemplateType, AiCreativeTemplateType> = {
  [CreativeTemplateType.DisplayAds]: AiCreativeTemplateType.DisplayAd,
  [CreativeTemplateType.VideoAds]: AiCreativeTemplateType.VideoAd,
  [CreativeTemplateType.ImageAds]: AiCreativeTemplateType.ImageAd,
  [CreativeTemplateType.InteractiveVideoAds]: AiCreativeTemplateType.InteractiveVideoAd,
  [CreativeTemplateType.InBannerVideoAds]: AiCreativeTemplateType.InBannerVideoAd,
};

const templateSourceConversions: Record<CreativeTemplateSource, string> = {
  [CreativeTemplateSource.ClinchSDK]: AiCreativeTemplateSource.ClinchSDK,
  [CreativeTemplateSource.AdBuilder]: AiCreativeTemplateSource.AdBuilder,
  [CreativeTemplateSource.AfterEffect]: 'After Effects',
};

const creativeTemplatesSchema: FilterToolSchemaField<CreativeTemplate>[] = [
  {name: 'id', type: 'number'},
  {name: 'name', type: 'string'},
  {
    name: 'type',
    type: 'number',
    description: `Converted from numbers to strings and vice versa in the following way: ${Object.entries(
      templateTypeConversions,
    )
      .map(([key, value]) => `${key}: ${value}`)
      .join(',')}`,
  },
  {
    name: 'source',
    type: 'string',
    description: `Should be converted from strings to strings and vice versa in the following way: ${Object.entries(
      templateSourceConversions,
    )
      .map(([key, value]) => `${key}: ${value}`)
      .join(',')}`,
  },
  {name: 'createTime', type: 'string'},
  {name: 'updateTime', type: 'string'},
  {
    name: 'createdByUserName',
    type: 'string',
    description:
      'The user who created the creative template, might contain partial name (e.g. "John" VS "John Doe").',
  },
  {
    name: 'updatedByUserName',
    type: 'string',
    description:
      'The user who updated the creative template, might contain partial name (e.g. "John" VS "John Doe").',
  },
  {name: 'features', type: 'Array<string>'},
  {
    name: 'formats',
    type: 'Array<{format: {formatString: string; Width: number; Height: number}}>',
    description:
      'Creative template formats. Filter by format.formatString, format.Width, or format.Height',
  },
  {
    name: 'creativeIdInActiveCampaigns',
    type: 'Record<number, {campaignId: number; campaignName: string}[]>',
    description:
      'If creativeIdInActiveCampaigns is empty, template has no creative used in live campaigns.',
  },
];

export {creativeTemplatesSchema};
